import { Helmet } from 'react-helmet-async';
import { filter } from 'lodash';
import { sentenceCase } from 'change-case';
import { useContext, useEffect, useRef, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import SwipeableViews from 'react-swipeable-views';
// @mui
import {
  Card,
  Table,
  Stack,
  Paper,
  Avatar,
  Button,
  Popover,
  Checkbox,
  TableRow,
  MenuItem,
  TableBody,
  TableCell,
  Container,
  Typography,
  IconButton,
  TableContainer,
  TablePagination,
  Grid,
  CircularProgress,
  Divider,
  Tabs,
  Tab,
  AppBar,
  Box,
} from '@mui/material';
import Snackbar from '@mui/material/Snackbar';
import Alert from '@mui/material/Alert';
import PropTypes from 'prop-types';
import ContactInforamtion from 'src/components/Company/ContactInforamtion';
import BusinessInforamtion from 'src/components/Company/BusinessInforamtion';
import CompanyInforamtion from 'src/components/Company/CompanyInforamtion';
import BusinessDetails from 'src/components/Company/BusinessDetails';
import ForeignWorkerInformation from 'src/components/Company/ForeignWorkerInformation';
import CreateCompany from 'src/components/Company/CreateCompany';
import { GetCompany, GetFootfall, GetRoles, GetVacancy } from 'src/components/services/httpServices';
import EditCompany from 'src/components/Company/EditCompany';
import TestPage from 'src/components/Company/test';
import { AuthContext } from '../Context/Auth/auth.context';
function TabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`full-width-tabpanel-${index}`}
      aria-labelledby={`full-width-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box sx={{ p: 3 }}>
          <Typography>{children}</Typography>
        </Box>
      )}
    </div>
  );
}
function a11yProps(index) {
  return {
    id: `full-width-tab-${index}`,
    'aria-controls': `full-width-tabpanel-${index}`,
  };
}
TabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.number.isRequired,
  value: PropTypes.number.isRequired,
};
export default function VacancyDetails() {
  let { id } = useParams();
  const navigate = useNavigate();
  const [vertical, setVertical] = useState('bottom');
  const [horizontal, setHorizontal] = useState('right');
  const [open, setOpen] = useState(false);
  const [saved, setSaved] = useState(false);
  const [loading, setLoading] = useState(true);
  const [message, setMessage] = useState('sdsdsdsds');
  const [vacancy, setVacancy] = useState({});
  let {
    authState: { deptId },
  } = useContext(AuthContext);
  const fetch = async (event) => {
    const savedVacancy = await GetVacancy(id);
    setVacancy(savedVacancy);
    setLoading(false);
  };
  useEffect(() => {
    fetch();
  }, []);

  const handleClose = () => {
    setOpen(false);
  };

  return (
    <>
      <Helmet>
        <title> Job Details | Immigration System </title>
      </Helmet>
      <Container>
        <Stack direction="row" alignItems="center" justifyContent="space-between" mb={5}>
          <Typography variant="h4" gutterBottom>
            {vacancy?.vacancyName}
          </Typography>

          <Stack direction="row" spacing={2}>
            {/* <Button
              onClick={() => {
                navigate(-1);
              }}
              variant="contained"
            >
              Back
            </Button> */}
          </Stack>
        </Stack>
        {loading ? (
          <Grid display="flex" alignItems="center" justifyContent="center" height="40vh" container>
            <CircularProgress size={60} thickness={3} value={100} />
          </Grid>
        ) : (
          <Box
            p={4}
            component={Paper}
            boxShadow={3}
            sx={{ border: 0, borderColor: 'primary.main', borderRadius: '16px' }}
          >
            <Grid container spacing={3}>
              <Grid item xs={6} sm={3} md={3}>
                <Typography variant="h6" color="initial">
                  Vacancy Name :{' '}
                </Typography>
                <Typography variant="subtitle" color="initial">
                  {vacancy?.vacancyName}
                </Typography>
              </Grid>
              <Grid item xs={6} sm={3} md={3}>
                <Typography variant="h6" color="initial">
                  Vacancy Type :{' '}
                </Typography>
                <Typography variant="subtitle" color="initial">
                  {vacancy?.vacancyType}
                </Typography>
              </Grid>
              <Grid item xs={6} sm={3} md={3}>
                <Typography variant="h6" color="initial">
                  Number of Positions :{' '}
                </Typography>
                <Typography variant="subtitle" color="initial">
                  {vacancy?.noOfVac}
                </Typography>
              </Grid>
              <Grid item xs={6} sm={3} md={3}>
                <Typography variant="h6" color="initial">
                  Origin :{' '}
                </Typography>
                <Typography variant="subtitle" color="initial">
                  {vacancy?.location}
                </Typography>
              </Grid>
              <Grid item xs={6} sm={3} md={3}>
                <Typography variant="h6" color="initial">
                  Salary Range :{' '}
                </Typography>
                <Typography variant="subtitle" color="initial">
                  {vacancy?.salaryRange}
                </Typography>
              </Grid>
              {/* <Grid item xs={6} sm={3} md={3}>
                <Typography variant="h6" color="initial">
                  Job Shift :{' '}
                </Typography>
                <Typography variant="subtitle" color="initial">
                  {vacancy?.shift}
                </Typography>
              </Grid> */}
              <Grid item xs={6} sm={3} md={3}>
                <Typography variant="h6" color="initial">
                  Position :{' '}
                </Typography>
                <Typography variant="subtitle" color="initial">
                  {vacancy?.positionName}
                </Typography>
              </Grid>
              <Grid item xs={6} sm={3} md={3}>
                <Typography variant="h6" color="initial">
                  Employment Type :{' '}
                </Typography>
                <Typography variant="subtitle" color="initial">
                  {vacancy?.employmentType}
                </Typography>
              </Grid>
              <Grid item xs={6} sm={3} md={3}>
                <Typography variant="h6" color="initial">
                  Joining Date :{' '}
                </Typography>
                <Typography variant="subtitle" color="initial">
                  {vacancy?.startDate?.split('T')[0]}
                </Typography>
              </Grid>
              <Grid item xs={6} sm={3} md={3}>
                <Typography variant="h6" color="initial">
                  Remarks :{' '}
                </Typography>
                <Typography variant="subtitle" color="initial">
                  {vacancy?.remarks}
                </Typography>
              </Grid>
              <Grid item xs={6} sm={3} md={3}>
                <Typography variant="h6" color="initial">
                  Description :{' '}
                </Typography>
                <Typography variant="subtitle" color="initial">
                  {vacancy?.description}
                </Typography>
              </Grid>
            </Grid>
          </Box>
        )}
      </Container>
      {saved ? (
        <Snackbar
          anchorOrigin={{ vertical, horizontal }}
          key={vertical + horizontal}
          open={open}
          autoHideDuration={4000}
          onClose={handleClose}
        >
          <Alert elevation={6} variant="filled" onClose={handleClose} severity="success">
            {message}
          </Alert>
        </Snackbar>
      ) : (
        <Snackbar
          key={vertical + horizontal}
          anchorOrigin={{ vertical, horizontal }}
          open={open}
          autoHideDuration={4000}
          onClose={handleClose}
        >
          <Alert elevation={6} variant="filled" onClose={handleClose} severity="error">
            {message}
          </Alert>
        </Snackbar>
      )}
    </>
  );
}
